import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'semantic-ui-react';

import './MultiSelect.css';

const MultiSelect = props => {
  const { className } = props;
  return (
    <Dropdown
      {...props}
      className={`multi-select-dropdown__component ${className}`}
    />
  );
};

MultiSelect.propTypes = {
  className: PropTypes.string,
};
MultiSelect.defaultProps = {
  className: '',
};

export default MultiSelect;
